import { Field } from "Shared/Form";

export const mapFieldsToValues = (fields: { [index: string]: Field }, formData: { [index: string]: string }) => {
    const newFields = { ...fields };

    Object.keys(fields).forEach((key) => {
        if (formData.hasOwnProperty(key)) {
            newFields[key].initialValue = formData[key];
        }
    });

    return newFields;
};
